import React from "react";
import { styled, withStyles } from "@mui/styles";
import Tooltip from "@mui/material/Tooltip";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { FormHelperText } from "@mui/material";
import {
  ownerUserType,
  serviceProviderUserType,
  resellerUserType,
  distributorUserType,
  adminUserType,
  accountAdminType,
} from "../userDataTypes";
import { timeZonesTypes } from "../../Attributes/timezone";

export const formStyles = (theme) => ({
  container: { display: "flex", flexWrap: "wrap" },
  dense: { marginTop: 19 },
  menu: { width: 200 },
  button: {},
  grid: { width: "60%" },
  label: { marginTop: -4 },
  shrink: { marginTop: 0 },
  focused: { marginTop: 0 },
  margin: {},
  cssLabel: { "&$cssFocused": {} },
  cssFocused: {},
  cssUnderline: { "&:after": {} },
  cssOutlinedInput: { "&$cssFocused $notchedOutline": {} },
  notchedOutline: {},
  input: { padding: "12px 14px 12px" },
});

export const HtmlTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    border: "1px solid #dadde9",
  },
}))(Tooltip);

export const ValidationIcon = ({ isValid, message }) => (
  <div style={{ display: "flex", alignItems: "center" }}>
    {isValid ? (
      <CheckCircleIcon style={{ color: "green", fontSize: 12 }} />
    ) : (
      <CancelIcon style={{ color: "red", fontSize: 12 }} />
    )}
    <span style={{ marginLeft: "5px", color: "gray" }}>{message}</span>
  </div>
);

export const PasswordRequirements = ({
  hasLengthValid,
  hasNumberValid,
  hasUpperCaseValid,
  hasLowerCaseValid,
  hasSpecialCharValid,
  translate,
}) => (
  <FormHelperText style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
    <ValidationIcon
      isValid={hasLengthValid}
      message={translate("Length must be at least 8 characters")}
    />
    <ValidationIcon
      isValid={hasNumberValid}
      message={translate("Must contain at least one Number")}
    />
    <ValidationIcon
      isValid={hasUpperCaseValid}
      message={translate("Must contain at least one Uppercase letter")}
    />
    <ValidationIcon
      isValid={hasLowerCaseValid}
      message={translate("Must contain at least one Lowercase letter")}
    />
    <ValidationIcon
      isValid={hasSpecialCharValid}
      message={translate(
        "Must contain at least one Special character (!@#$%^&*(),.?:{}|<></>)",
      )}
    />
  </FormHelperText>
);

export const WhiteTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  "& .MuiTooltip-tooltip": {
    backgroundColor: "white",
    color: "black",
    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
    border: "1px solid #ddd",
    fontSize: "14px",
  },
  "& .MuiTooltip-arrow": {
    color: "white",
  },
}));

export const getUserTypeOptions = (userType) => {
  if (userType === -1) return ownerUserType;
  if (userType === 2) return adminUserType;
  if (userType === 3) return accountAdminType;
  if (userType === 4) return serviceProviderUserType;
  if (userType === 5) return resellerUserType;
  if (userType === 6) return distributorUserType;
  return [];
};

export const defaultTimezoneOptions = () =>
  timeZonesTypes.map((item) => ({
    id: item.key,
    key: item.key,
    label: item.label,
    value: item.key,
  }));

export const decodeFileUrl = (url = "") => {
  let decoded = String(url || "");
  while (decoded.includes("&amp;")) {
    decoded = decoded.replace(/&amp;/gi, "&");
  }
  return decoded.replace(/amp;/g, "&");
};

export const downloadUserFile = (event, data) => {
  event.preventDefault();
  const url = decodeFileUrl(data?.url);
  if (!url) return;
  const fileName = data?.fileName || "download";
  fetch(url)
    .then((response) => {
      if (!response.ok) throw new Error("download failed");
      return response.blob();
    })
    .then((blob) => {
      const objectUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = objectUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(objectUrl);
    })
    .catch(() => {
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
};

export const selectMe = (element) => {
  const doc = document;
  const text = element.target;
  let range;
  let selection;
  if (doc.body.createTextRange) {
    range = document.body.createTextRange();
    range.moveToElementText(text);
    range.select();
  } else if (window.getSelection) {
    selection = window.getSelection();
    range = document.createRange();
    range.selectNodeContents(text);
    selection.removeAllRanges();
    selection.addRange(range);
  }
};
